import { render } from "./AppButton.vue?vue&type=template&id=00cef167&scoped=true&ts=true&lang=pug"
import script from "./AppButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppButton.vue?vue&type=script&lang=ts&setup=true"

import "./AppButton.vue?vue&type=style&index=0&id=00cef167&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00cef167"]])

export default __exports__